import { updateField } from 'vuex-map-fields';
export default {
    updateLoginField(state, field) {
        updateField(state.loginForm, field);
    },
    updateResetPasswordField(state, field) {
        updateField(state.resetPasswordForm, field);
    },
    updateChangePasswordField(state, field) {
        updateField(state.changePasswordForm, field);
    },
    clearPasswordField(state,type) {
        if(type === 'changePassword') {
            state.changePasswordForm.old_password = ''
            state.changePasswordForm.new_password = ''
            state.changePasswordForm.confirm_password = ''
        } else {
            state.loginForm.password = ''
            state.resetPasswordForm.recovery_password = ''
            state.resetPasswordForm.new_password = ''
            state.resetPasswordForm.confirm_password = ''
        }
    },
}